module.exports = __webpack_public_path__ + "img/word.b425027a.svg";